import { Locale } from '@silae/composables/i18n';

export function formatLocale(locale: Locale) {
	if (!locale) {
		return 'fr-FR';
	}

	const { value, ISO } = locale;
	const iso = ISO ?? value?.toUpperCase();

	return `${value}-${iso}`;
}
